class SnowEffect {
    constructor() {
        this.options = {
            flakesMax: 40,
            excludeMobile: false,
            snowColor: '#fff',
            snowCharacter: '•',
            zIndex: 0,
            container: document.body
        };

        this.flakes = [];
        this.active = false;
        this.resizeTimeout = null;
        this.animationFrameId = null;
        this.isMobile = /mobile|android|ios/i.test(navigator.userAgent);
        this.isVisible = true;

        // Bind methods
        this.updateBounds = this.updateBounds.bind(this);
        this.animate = this.animate.bind(this);
        this.init = this.init.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    init() {
        if (this.options.excludeMobile && this.isMobile) return;

        // Reduce flakes on mobile for better performance
        if (this.isMobile && this.options.flakesMax > 20) {
            this.options.flakesMax = 20;
        }

        // Create snow container with specific z-index
        this.snowContainer = document.createElement('div');
        this.snowContainer.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      pointer-events: none;
      z-index: ${this.options.zIndex};
      will-change: transform;
    `;
        this.options.container.appendChild(this.snowContainer);

        // Create initial snowflakes
        this.createFlakes();

        // Set up event listeners
        window.addEventListener('resize', () => {
            if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.updateBounds, 200);
        });

        // Pause animation when tab is hidden to save CPU
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        // Start animation
        this.active = true;
        this.animate();
    }

    createFlakes() {
        const fragment = document.createDocumentFragment();

        for (let i = 0; i < this.options.flakesMax; i++) {
            const flake = document.createElement('div');

            flake.style.cssText = `
        position: absolute;
        color: ${this.options.snowColor};
        pointer-events: none;
        user-select: none;
        top: -10px;
        border-radius: 50%;
        opacity: ${Math.random()};
        transform: translate3d(0, 0, 0);
        will-change: transform;
      `;

            // Randomize initial position
            flake.style.left = Math.random() * 100 + '%';
            flake.innerHTML = this.options.snowCharacter;

            this.flakes.push({
                element: flake,
                x: Math.random() * 100,
                y: -10,
                speed: 1 + Math.random(),
                wobble: Math.random() * 10
            });

            fragment.appendChild(flake);
        }

        this.snowContainer.appendChild(fragment);
    }

    updateBounds() {
        // Update positions if needed
    }

    animate() {
        if (!this.active || !this.isVisible) {
            this.animationFrameId = null;
            return;
        }

        // Batch DOM updates for better performance
        this.flakes.forEach(flake => {
            flake.y += flake.speed;
            // Optimize: cache sin calculation, only update when needed
            const wobbleOffset = Math.sin(flake.y * 0.01) * flake.wobble;
            flake.x += wobbleOffset * 0.1;

            // Reset flake when it goes off screen
            if (flake.y > window.innerHeight) {
                flake.y = -10;
                flake.x = Math.random() * 100;
            }

            flake.element.style.transform = `translate3d(${flake.x}%, ${flake.y}px, 0)`;
        });

        this.animationFrameId = requestAnimationFrame(this.animate);
    }

    start() {
        if (!this.active) {
            this.active = true;
            this.animate();
        }
    }

    stop() {
        this.active = false;
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
    }

    handleVisibilityChange() {
        this.isVisible = !document.hidden;
        if (this.isVisible && this.active && !this.animationFrameId) {
            this.animate();
        }
    }

    destroy() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.snowContainer && this.snowContainer.parentNode) {
            this.snowContainer.parentNode.removeChild(this.snowContainer);
        }
        this.flakes = [];
    }
}

// CSS animation removed - JavaScript handles all animation for better performance

// Usage - wrap in DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    const snow = new SnowEffect();
    // Start snow effect
    snow.init();
});